/**
 * 語言相關的工具函數
 *
 * 這個檔案曾經持有一份 5 個語系的 LANGUAGE_MAP，以及 12 個從它衍生的匯出
 * （isValidLanguage、getSupportedLanguages、getBrowserPreferredLanguage 等）。
 * 全部沒有任何消費者，卻是「支援哪些語系」的第 7 份定義，跟後端的服務清單各說
 * 各話。哪些語系有服務是後端的事（config/supported_locales.rb），前端不需要
 * 自己保存一份，所以那份地圖與依賴它的死碼一起移除。
 */

const DEFAULT_LANGUAGE = 'zh-TW';

/**
 * 這一頁被渲染成哪個語系。
 *
 * 以前是讀 `?locale=` 查詢參數。後台頁面靠每個連結重複帶上那個參數才維持正確，
 * 而公開頁的 `/en/<slug>` 從來就沒有那個參數 —— 所以英文頁上的價格與日期一直
 * 是用 zh-TW 格式渲染的。`?locale=` 已不再是 locale 來源，改讀後端解析完寫進
 * `<html lang>` 的結果，兩個問題一起沒有。
 *
 * @param {string} defaultLanguage - 頁面沒有宣告語言時的後備
 * @returns {string} 語言代碼
 */
export const getCurrentLocale = (defaultLanguage = DEFAULT_LANGUAGE) => {
  try {
    return document.documentElement.lang || defaultLanguage;
  } catch (error) {
    return defaultLanguage;
  }
};
